import { Component, OnInit } from '@angular/core';

import { ExcelService } from '../excel.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as moment from 'moment';
import { VillageStaffService } from '../village-staff.service';
import { vovSharedService } from 'src/app/shared/services/vov-shared.service';


@Component({
  selector: 'app-enforcement',
  templateUrl: './enforcement.component.html',
  styleUrls: ['./enforcement.component.scss']
})
export class EnforcementComponent implements OnInit {
  public enforcement = [];
  public columnNames = {
    plateNo: 'Plate No.',
    date: 'Date',
    time: 'Time',
    action: 'Action',
    streetNo: 'Street Number',
    street: 'Street',
    user: 'Officer Id',
  };
  public maxDate;
  public showSpinner: boolean = false;
  dateForm: FormGroup;
  public streets = [];
  public firstYearDate = moment().startOf('year').format('YYYY-MM-DD');

  constructor(private excelService: ExcelService,
    private villageStaffService: VillageStaffService,
    private formBuilder: FormBuilder,
    private vovSharedService: vovSharedService) { }

  ngOnInit(): void {
    this.dateForm = this.formBuilder.group({
      startDate: [''],
      endDate: [''],
      street: [''],
      plateNo: ['']

    });
    this.onSubmitDates();
    this.vovSharedService.fetchAllStreets().subscribe((res) => {
      this.streets = res.streetsList;
      this.streets.sort((a, b) => a.street.localeCompare(b.street));
    });
  }

  onSubmitDates() {
    this.showSpinner = true;
    console.log(this.dateForm.value)
    let params = this.dateForm.value;
    params.startDate = params.startDate ? moment(params.startDate).format('YYYY-MM-DD') : moment(this.firstYearDate).format('YYYY-MM-DD');
    params.endDate = params.endDate ? moment(params.endDate).format('YYYY-MM-DD') : new Date();
    console.log(params)
    this.villageStaffService.getEnforcemetHistory(params).subscribe((res: any) => {
      let enforcement = [];
      res.enforcementData.sort((a, b) => <any>new Date(b.date).getTime() - <any>new Date(a.date).getTime())
      res.enforcementData.map((data: any) => {
        const statePlate = (data.states ? data.states.state : null) + '-' + data.plateNo
        let enf = {
          plateNo: statePlate,
          date: moment(data.date).format("MM/DD/YY"),
          time: moment(data.date).format('h:mm a'),
          action: data.action ? data.action.action : '--',
          streetNo: data.streetNumber ? data.streetNumber : '0',
          street: data.streets ? data.streets.street : '',
          user: data.user ? data.user.userName : '',
        }
        enforcement.push(enf)
      })

      this.enforcement = enforcement;
      this.showSpinner = false;
    });
  }

  reset() {
    this.dateForm.reset()
    this.onSubmitDates();
  }

  exportAsXLSX(): void {
    this.excelService.exportAsExcelFile(this.enforcement, 'sample');
  }
}
